import i18n from "../i18n";
import * as Yup from "yup";

export const createEntryStickerForParkingVehicleSchema = (isAttachments: {
  haveVehicleRegLicense: number;
}) => {
  return Yup.object({
    plateSource: Yup.string().required(
      i18n.language === "en" ? "Plate type is required." : "نوع اللوحة مطلوب."
    ),
    plateLetter1: Yup.string().required(
      i18n.language === "en"
        ? "Plate Letter 1 is required."
        : "الحرف الأول من اللوحة مطلوب."
    ),
    plateLetter2: Yup.string().required(
      i18n.language === "en"
        ? "Plate Letter 2 is required."
        : "الحرف الثاني من اللوحة مطلوب."
    ),
    plateLetter3: Yup.string().required(
      i18n.language === "en"
        ? "Plate Letter 3 is required."
        : "الحرف الثالث من اللوحة مطلوب."
    ),
    plateNumber: Yup.string()
      .nullable()
      .matches(
        /^[0-9\u0660-\u0669]{1,6}$/,
        i18n.language === "en"
          ? "Enter a valid plate number."
          : "أدخل رقم لوحة صالح."
      )
      .required(
        i18n.language === "en"
          ? "Plate Number is required."
          : "رقم اللوحة مطلوب."
      ),

    color: Yup.string().required(
      i18n.language === "en" ? "Color is required." : "اللون مطلوب."
    ),

    model: Yup.string().required(
      i18n.language === "en" ? "Model is required." : "الموديل مطلوب."
    ),

    stickerParkingNumber: Yup.string().required(
      i18n.language === "en"
        ? "Sticker/Parking Number is required."
        : "رقم الملصق/الباركينج مطلوب."
    ),

    copyNumber: Yup.string().required(
      i18n.language === "en" ? "Copy Number is required." : "رقم النسخة مطلوب."
    ),

    uploadVehicleRegLicense: Yup.mixed().when([], {
      is: () => isAttachments?.haveVehicleRegLicense,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "Vehicle registration license is required."
            : "رخصة تسجيل المركبة مطلوبة."
        ),
    }),
  });
}
